// import React from "react";

// const Nlpbanner = () => {
//   const bannerStyles = {
//     marginTop:"60px",
//     width: "100%",
//     height: "90vh", 
//     backgroundImage: "url('/image/nlpbanimg.webp')",  
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     color: "white",
//     position: "relative",
//     overflow: "hidden",
//   };

//   const contentStyles = {
//     maxWidth: "90%",
//     padding: "0 20px", // Add some padding for mobile devices
//   };

//   const headingStyles = {
//     fontSize: "4rem", // Large heading
//     margin: 0,
//     lineHeight: 1.2,
//     fontWeight: "bold",
//   };

//   const paragraphStyles = {
//     fontSize: "1.5rem", // Medium size paragraph
//     marginTop: "1rem",
//   };

//   // Adjust text size for smaller screens using media queries in JS (inline-style can't directly do this)
//   const mediaQueryStyles = {
//     "@media (max-width: 1200px)": {
//       heading: { fontSize: "3.5rem" },
//       paragraph: { fontSize: "1.3rem" },
//     },
//     "@media (max-width: 768px)": {
//       heading: { fontSize: "2.5rem" },
//       paragraph: { fontSize: "1.2rem" },
//     },
//     "@media (max-width: 480px)": {
//       heading: { fontSize: "2rem" },
//       paragraph: { fontSize: "1rem" },
//     },
//   };

//   return (
//     <div style={bannerStyles}>
//       <div style={contentStyles}>
       
        
//       </div>
//     </div>
//   );
// };

// export default Nlpbanner;



import React from "react";
import { motion } from "framer-motion";

const Nlpbanner = () => {
  const bannerStyles = {
   // marginTop: "60px",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/nlpbanimg.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-start",  
    alignItems: "center", 
    color: "white",
    position: "relative",
    overflow: "hidden",
    paddingLeft: "60px",  
    textAlign: "left",
  };

  const contentStyles = {
    maxWidth: "600px",
  };

  const headingStyles = {
    fontSize: "28px",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    color:"white",
    letterSpacing:"0px",
  };

  const paragraphStyles = {
    fontSize: "22px",
    marginTop: "1rem",
    textAlign:"justify",
  };

  return (
    <div style={bannerStyles}>
      <motion.div
        style={contentStyles}
        initial={{ y: 100, opacity: 0 }} // Start from below
        animate={{ y: 0, opacity: 1 }} // Slide up
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <h2 style={headingStyles}>Natural Language Processing (NLP)</h2>
        <p style={paragraphStyles}>
          Unlock the power of human language with advanced NLP solutions.
          From chatbots to sentiment analysis, we help businesses
          understand and process text smarter than ever before.
        </p>
      </motion.div>
    </div>
  );
};

export default Nlpbanner;
